import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LockIcon, StoreIcon, PackageIcon, LayoutTemplateIcon, InboxIcon, LogOutIcon, ExternalLinkIcon } from 'lucide-react';
import { useContent } from '../ContentContext';
import { PartnerManager } from '../components/admin/PartnerManager';
import { ProductManager } from '../components/admin/ProductManager';
import { ContentManager } from '../components/admin/ContentManager';
import { RequestManager } from '../components/admin/RequestManager';
type Tab = 'partners' | 'sortiment' | 'startsida' | 'forfragningar';
const TABS: {
  id: Tab;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}[] = [{
  id: 'partners',
  label: 'Partners',
  icon: StoreIcon
}, {
  id: 'sortiment',
  label: 'Sortiment',
  icon: PackageIcon
}, {
  id: 'startsida',
  label: 'Startsida',
  icon: LayoutTemplateIcon
}, {
  id: 'forfragningar',
  label: 'Förfrågningar',
  icon: InboxIcon
}];
export function Admin() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState<Tab>('partners');
  const {
    businesses,
    requests
  } = useContent();
  if (!isLoggedIn) {
    return <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6 pt-20" data-id="element-344" data-mp="3bn3obqm2hzc4">
        <div className="w-full max-w-md rounded-3xl bg-white p-10 shadow-floating" data-id="element-345" data-mp="36o0smwrz95gt">
          <div className="mb-8 flex justify-center" data-id="element-346" data-mp="36q4wjepvm4h3">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-black text-white" data-id="element-347" data-mp="31pz7m6azqw2p">
              <LockIcon className="h-6 w-6" data-id="element-348" data-mp="2wxfj4earmgj4" />
            </div>
          </div>
          <h1 className="text-center font-display text-3xl font-medium text-gray-900" data-id="element-349" data-mp="2rycpdq08jwqg">Logga in</h1>
          <p className="mt-2 text-center text-sm text-gray-500" data-id="element-350" data-mp="2nybzn97orz43">Adminportal för Smaken som Baken</p>

          <form className="mt-8 space-y-5" onSubmit={e => {
          e.preventDefault();
          setIsLoggedIn(true);
        }} data-id="element-351" data-mp="2iyplmxk1aeu8">
            <div data-id="element-352" data-mp="2e0ecyq5h6adl">
              <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-353" data-mp="2dzv6c5l9z8ev">E-postadress</label>
              <input type="email" required placeholder="admin@smakensombaken.se" className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-354" data-mp="24dtx2n7fh81n" />
            </div>
            <div data-id="element-355" data-mp="1zehb04ods504">
              <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-356" data-mp="2n2ifn2ifv1a9">Lösenord</label>
              <input type="password" required placeholder="••••••••" className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-357" data-mp="2s1l8zpp23j2e" />
            </div>
            <button type="submit" className="mt-2 w-full rounded-full bg-black py-4 text-sm font-medium text-white transition-transform hover:scale-[1.02]" data-id="element-358" data-mp="360kx8w8npvy1">
              Logga in
            </button>
          </form>
        </div>
      </div>;
  }
  const newRequests = requests.filter(r => r.status === 'ny').length;
  const totalProducts = businesses.reduce((sum, b) => sum + b.products.length, 0);
  return <div className="flex min-h-screen bg-gray-50 pt-20" data-id="element-359" data-mp="194q9a7yyfcq8">
      <aside className="sticky top-20 hidden h-[calc(100vh-5rem)] w-64 shrink-0 flex-col border-r border-gray-100 bg-white p-6 md:flex" data-id="element-360" data-mp="144lucmdp2q24">
        <p className="text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-361" data-mp="gg2mg7yk4fak">Adminportal</p>

        <nav className="mt-8 space-y-1" data-id="element-362" data-mp="bgzsbik47thd">
          {TABS.map(({
          id,
          label,
          icon: Icon
        }) => <button key={id} onClick={() => setActiveTab(id)} className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${activeTab === id ? 'bg-black text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-363" data-mp="pcjxzcau2f6u">
              <Icon className="h-4 w-4" data-id="element-364" data-mp="2s2o8rv12mc0s" />
              {label}
              {id === 'forfragningar' && newRequests > 0 && <span className="ml-auto flex h-5 min-w-[20px] items-center justify-center rounded-full bg-gray-900 px-1.5 text-[10px] font-bold text-white" data-id="element-365" data-mp="2w51ckdw9bzux">
                  {newRequests}
                </span>}
            </button>)}
        </nav>

        <div className="mt-8 rounded-2xl bg-gray-50 p-4 text-xs text-gray-500" data-id="element-366" data-mp="3b1sfuy91xvpt">
          <p data-id="element-367" data-mp="3f2uhflqfyjuy">{businesses.length} partners</p>
          <p className="mt-1" data-id="element-368" data-mp="3f1svgm7w0cyg">{totalProducts} produkter</p>
        </div>

        <div className="mt-auto space-y-2 pt-6" data-id="element-369" data-mp="3jt2hlcu88y5l">
          <Link to="/" className="flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100" data-id="element-370" data-mp="3jucgu5ctgcdt">
            <ExternalLinkIcon className="h-4 w-4" data-id="element-371" data-mp="3ttbiv532t9ru" /> Visa sajten
          </Link>
          <button onClick={() => setIsLoggedIn(false)} className="flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100" data-id="element-372" data-mp="2mifpvoq30ko">
            <LogOutIcon className="h-4 w-4" data-id="element-373" data-mp="1i33o89qwqeyt" /> Logga ut
          </button>
        </div>
      </aside>

      <main className="min-w-0 flex-1 p-6 md:p-10" data-id="element-374" data-mp="1d5k8f5ek9u4r">
        {/* Mobile tabs */}
        <div className="mb-8 flex gap-2 overflow-x-auto md:hidden" data-id="element-375" data-mp="187ioki9b9qs8">
          {TABS.map(({
          id,
          label
        }) => <button key={id} onClick={() => setActiveTab(id)} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${activeTab === id ? 'bg-black text-white' : 'bg-white text-gray-600'}`} data-id="element-376" data-mp="25t7pwbkjc4n6">
              {label}
            </button>)}
        </div>

        {activeTab === 'partners' && <PartnerManager data-id="element-377" data-mp="2omjz5wl9g0wo" />}
        {activeTab === 'sortiment' && <ProductManager data-id="element-378" data-mp="2jspk56gloa3x" />}
        {activeTab === 'startsida' && <ContentManager data-id="element-379" data-mp="2jrxppyyqoif8" />}
        {activeTab === 'forfragningar' && <RequestManager data-id="element-380" data-mp="hwqg2t9wiy6f" />}
      </main>
    </div>;
}